import { datadogRum } from '@datadog/browser-rum';
import { env } from 'next-runtime-env';

export const initDatadogRum = () =>
  env('NEXT_PUBLIC_BO_ENV') === 'prod' || env('NEXT_PUBLIC_BO_ENV') === 'preprod'
    ? datadogRum.init({
        applicationId: env('NEXT_PUBLIC_DATADOG_APPLICATION_ID') || '',
        clientToken: env('NEXT_PUBLIC_DATADOG_CLIENT_TOKEN') || '',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'datadoghq.eu',
        service: 'front-client',
        env: env('NEXT_PUBLIC_BO_ENV'),
        // Specify a version number to identify the deployed version of your application in Datadog
        version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 5,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        trackingConsent: 'not-granted',
        // Specify URLs to propagate trace headers for connection between RUM and backend trace
        allowedTracingUrls: [
          {
            match: env('NEXT_PUBLIC_API_ENTRYPOINT') || 'https://api.altered.gg/',
            propagatorTypes: ['tracecontext'],
          },
        ],
        beforeSend(event) {
          // Next.js error that happen on navigation interruption
          if (event.type === 'error' && event.error.message.includes('Loading initial props cancelled')) {
            return false;
          }

          return true;
        },
      })
    : null;
